<template>
  <HubContainer id="companyUsersHub">

    <HubSection icon="icon/hub/settings.svg"
                :title="$t('roles.ROLE_CLERK')"
                :description="$t('roles.ROLE_CLERK_description')"
                :buttonAction="goToClerk">
    </HubSection>

    <HubSection icon="icon/hub/administrator.svg"
                :title="$t('roles.ROLE_COMPANY_ADMIN')"
                :description="$t('roles.ROLE_COMPANY_ADMIN_description')"
                :buttonAction="goToCompanyAdmin">
    </HubSection>

    <HubSection icon="icon/hub/commands.svg" v-if="atLeastDistributor"
                :title="$t('roles.ROLE_RECEPTION')"
                :description="$t('roles.ROLE_RECEPTION_description')"
                :buttonAction="goToRecep">
    </HubSection>

    <HubSection icon="icon/hub/employee.svg" v-if="moduleActivated.POS"
                :title="$t('employees.title')"
                :description="$t('employees.description')"
                :buttonAction="goToPOSEmployees">
    </HubSection>

    <HubSection icon="icon/hub/role-permission.svg" v-if="moduleActivated.POS"
                :title="$t('pos_roles.title')"
                :description="$t('pos_roles.description')"
                :buttonAction="goToRoles">
    </HubSection>


  </HubContainer>
</template>

<script>
import HubSection from "@/components/HubSection";
import HubContainer from "@/components/HubContainer";

export default {
  name: "CompanyUserHub",

  components: { HubSection, HubContainer },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "users.title";
    this.$store.state.pageIcon = "/icon/nav/users.svg";

    if (this.$route.query.branch) {
      let branchModule = await this.$store.getters.getContextBranchActivatedModule;
      Object.assign(this.moduleActivated, branchModule);
    }
    if (this.$route.query.company) {
      let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
      Object.assign(this.moduleActivated, companyModule);
    }
  },

  data() {
    return {
      moduleActivated: {
        onlineOrdering: false,
        kiosk: false,
        mobileApp: false,
        menuBoard: false,
        loyalty: false,
        thirdPartyLoyalty: false,
        aimsVouchers: false,
        onSiteOrdering: false,
        payAtTheTable: false,
        catering: false,
        dispatch: false,
        POS: false,
      }
    }
  },

  computed: {
    atLeastSuperAdmin() {
      return this.$store.getters.loggedUserHasSuperAdmin;
    },
    atLeastDistributor() {
      return this.$store.getters.loggedUserHasDistributor;
    }
  },

  methods: {
    goToCompanyAdmin() {
      this.$router.push(this.$router.buildContext("/users/ROLE_ADMIN"));
    },
    goToClerk() {
      this.$router.push(this.$router.buildContext("/users/ROLE_CLERK"));
    },
    goToRecep() {
      this.$router.push(this.$router.buildContext("/users/ROLE_RECEPTION"));
    },
    goToPOSEmployees() {
      this.$router.push(this.$router.buildContext("/employees"));
    },
    goToRoles() {
      this.$router.push(this.$router.buildContext("/roles"));
    }
  }
}
</script>